

















import { Tabs } from '@/app/components';

import { useQueryParams } from '@/app/composable';
import { useRouter } from '@/app/composable/router';
import { CreditCardIcon, DocumentTextIcon, SearchIcon, ShoppingCartIcon } from '@vue-hero-icons/outline';
import { computed, defineComponent } from '@vue/composition-api';
import { Cart, Contracts, Explore, Wallet } from '../components';

export default defineComponent({
    name: 'Marketplace',
    metaInfo: {
        title: 'Marketplace',
    },
    components: {
        Tabs,
        Contracts,
        Explore,
        Cart,
        Wallet,
    },
    setup(props, { root }) {
        const router = useRouter();
        const { get, set } = useQueryParams(root, router, 'marketplace');

        const activeTab = computed({
            get: () => get('tab', false, tabs[0].key),
            set: (newTab: string) => set('tab', newTab, tabs[0].key),
        });

        const tabIndex = computed({
            get: () => tabs.findIndex((t: { key: string; title: string }) => t.key === activeTab.value.split('-')[0]),
            set: (newIndex: number) => (activeTab.value = tabs[newIndex].key),
        });

        const tabs = [
            { id: 0, title: 'Explore', icon: SearchIcon, key: 'explore' },
            { id: 1, title: 'My Contracts', icon: DocumentTextIcon, key: 'contracts' },
            { id: 2, title: 'My Cart', icon: ShoppingCartIcon, key: 'cart' },
            { id: 3, title: 'My Wallet', icon: CreditCardIcon, key: 'wallet' },
        ];

        const clearQueryParams = () => {
            const queryParams = Object.keys(root.$route.query).filter((key) => key !== 'tab');
            if (queryParams.length) root.$router.replace({ name: 'marketplace', query: { tab: activeTab.value } });
        };

        return { tabs, tabIndex, clearQueryParams };
    },
});
